<template>
  <div>
    <el-card>
      <!--基础信息-->
      <div style="font-size: 14px; color: #606266;">
        <span>No：{{ formData.deNo }}</span>
        <el-divider direction="vertical"></el-divider>
        <span>Status：{{ formData.deStatusName }}</span>
        <el-divider direction="vertical"></el-divider>
        <span
          >Create：{{ formData.createByName }} at
          {{ formData.createDate }}</span
        >
        <el-divider direction="vertical"></el-divider>
        <span
          >Modify：{{ formData.modifyByName }} at
          {{ formData.modifyDate }}</span
        >
      </div>
      <div class="d2-mt">
        <el-form ref="formData" :model="formData" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_category') || '素材分类'"
                prop="deCategoryCode"
              >
                <dict-select
                  v-model="formData.deCategoryCode"
                  :disabled="disabled"
                  filterable
                  clearable
                  url="/digitalCenter/common/dict/elementCategorySelect"
                  size="medium"
                  :placeholder="$l('form_label_category') || '素材分类'"
                  style="width: 100%"
                ></dict-select>
              </el-form-item>
              <!-- <el-form-item :label="$l('form_label_customer') || '客户名称'" prop="custCode">
                    <dict-select
                      v-model="formData.custCode"
                      :disabled="disabled"
                      filterable
                      clearable
                      url="/digitalCenter/common/dict/customer"
                      size="medium"
                      :placeholder="$l('form_label_customer') || '客户名称'"
                      style="width: 100%"
                    ></dict-select>
                  </el-form-item>-->
              <el-form-item
                :label="$l('form_label_name_cn') || '中文名称'"
                prop="deName"
              >
                <el-input
                  v-model="formData.deName"
                  :placeholder="$l('form_label_name_cn') || '中文名称'"
                  maxlength="50"
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$l('form_label_name_en') || '英文名称'"
                prop="deNameEn"
              >
                <el-input
                  v-model="formData.deNameEn"
                  :placeholder="$l('form_label_name_en') || '英文名称'"
                  maxlength="50"
                  disabled
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$l('form_label_describe') || '素材描述'"
                prop="deMemo"
              >
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 6 }"
                  v-model="formData.deMemo"
                  maxlength="200"
                  :disabled="disabled"
                  clearable
                  size="medium"
                  :placeholder="$l('form_label_describe') || '素材描述'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-col :sm="{ span: 20 }" :md="{ span: 10 }" :lg="{ span: 10 }">
                <uploader-image
                  :multiple="false"
                  :thumbnail="{ quality: 0.2 }"
                  :on-added="onAdded"
                  :data="{
                    url: $osscdn(formData.deImageCode),
                    turl: $osscdn(formData.deThumbImageCode)
                  }"
                ></uploader-image>
              </el-col>
              <el-col :span="4" style="text-align: center">
                <i
                  class="el-icon-right icon-right"
                  style="width:180px;height:10px;"
                  v-show="false"
                ></i>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <!-- <el-collapse v-model="activeName" accordion>
                    <el-collapse-item name="1">
                      <template slot="title">
                        <h6>
                          <i>Attribute</i>
                        </h6>
                      </template> -->
              <Attribute
                size="medium"
                :span="8"
                ref="attribute"
                :params="attrParams"
                :disabled="disabled"
              />
              <!-- </el-collapse-item>
                  </el-collapse> -->
            </el-col>
          </el-row>
          <!--按钮-->
          <div class="d2-mt">
            <el-row>
              <el-col :span="20">
                <el-button
                  @click="save"
                  size="small"
                  type="primary"
                  v-if="!disabled"
                  >{{ $l('form_button_save') || '保存' }}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
import Attribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  components: {
    Attribute
  },
  data() {
    return {
      activeName: '1',
      pageHeader: '',
      dialogVisible: false,
      dialogVisible2: false,
      disabled: false,
      categoryOptions: {},
      fileData: {
        // 文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles'
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: localStorage.getItem('token')
      },
      itemTagList: ['夹克', '加绒', '短款'],
      itemAttributeList: ['属性1', '属性2', '属性3'],
      formData: {
        deCode: '',
        deName: '',
        deNameEn: '',
        tagList: [],
        deStatus: 'Y',
        custCode: '',
        deCategoryCode: '',
        deImageCode: '',
        deImageUrl: '',
        deThumbImageCode: '',
        deThumbImageUrl: '',
        deMemo: '',
        createByName: '',
        createDate: '',
        modifyDate: '',
        modifyByName: ''
      },
      rules: {
        deStatus: [
          {
            required: true,
            message: this.$l('form_rule_destatus') || '请选择有效状态',
            trigger: 'change'
          }
        ],
        deCategoryCode: [
          {
            required: true,
            message: this.$l('form_rule_category') || '请选择素材分类',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    if (this.$route.params.deCode) {
      let type = this.$route.params.pageType
      let deCode = this.$route.params.deCode
      this.init(type, deCode)
    }
  },
  activated() {
    if (this.$route.params.deCode) {
      let type = this.$route.params.pageType
      let deCode = this.$route.params.deCode
      this.init(type, deCode)
    }
  },
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.deCode,
        templateCategoryCode: this.formData.deCategoryCode,
        templateType: 'D'
      }
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    onAdded({ md5, isThumb, suffix }) {
      let code = md5 + '.' + suffix
      if (isThumb) {
        this.formData.deImageCode = code
      } else {
        this.formData.deThumbImageCode = code
      }
    },
    init(type, deCode) {
      this.activeName = '1'
      this.resetData()
      if (type === 'edit') {
        this.updateLoad(deCode)
      } else if (type === 'detail') {
        this.detailLoad(deCode)
      } else if (type === 'add') {
        this.addLoad(deCode)
      }
    },
    addLoad(val) {
      if (this.$refs.formData) {
        this.$refs.formData.resetFields()
      }
      const array = val.split('=')
      this.pageHeader = this.$l('page_title_add') || '素材新增'
      this.disabled = false
      this.formData.deStatusName = this.$l('form_radio_valid') || '有效'
      this.formData.deNo = 'No Data'
      this.formData.createByName = 'No Data'
      this.formData.createDate = 'No Data'
      this.formData.modifyDate = 'No Data'
      this.formData.modifyByName = 'No Data'
      this.formData.deCategoryCode = array[0]
      this.formData.custCode = array[1]
      this.$refs.attribute.load(this.attrParams)
    },
    updateLoad(val) {
      this.pageHeader = this.$l('page_title_edit') || '素材编辑'
      this.disabled = false
      let param = { deCode: val }
      this.$api.detailDesignElementsInfoApi(param).then((res) => {
        this.formData = res.body
        this.$refs.attribute.load(this.attrParams)
      })
    },
    detailLoad(val) {
      this.pageHeader = this.$l('page_title_view') || '素材详情'
      this.disabled = true
      let param = { deCode: val }
      this.$api.detailDesignElementsInfoApi(param).then((res) => {
        this.formData = res.body
        if (this.formData.deStatus === 'Y') {
          this.formData.deStatusName = this.$l('form_radio_valid') || '有效'
        } else {
          this.formData.deStatusName = this.$l('form_radio_invalid') || '无效'
        }
        this.$refs.attribute.load(this.attrParams)
      })
    },
    // 保存数据
    save() {
      this.saveData()
    },
    saveData() {
      const form = this.$refs.formData
      const attrForm = this.$refs.attribute.$refs.form
      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.formData.attrData = this.$refs.attribute.getFormData()
          //验证素材描述和属性是否都为空
          let result = this.validDeMemoAndElements(this.formData)
          if (result) {
            this.$api.saveDesignElementsInfoApi(this.formData).then(() => {
              this.saveOkQuestion()
            })
          }
        }
      })
    },
    //验证素材描述和属性是否都为空
    validDeMemoAndElements(formData) {
      if (formData.deMemo) {
        return true
      } else {
        //判断属性是否都为空
        let attributeList = formData.attrData.attributeList
        let result = false
        if (attributeList) {
          attributeList.forEach((item, key) => {
            if (item.attributeValueZh) {
              result = true
            }
          })
        }
        if (result) {
          return true
        } else {
          this.$message.warning(
            this.$l('tips_materialDescription') ||
              '素材描述和Attribute不能都为空！'
          )
          return false
        }
      }
    },
    handleTagClose(tag) {
      this.itemTagList.splice(this.itemTagList.indexOf(tag), 1)
    },
    handleAttributeClose(tag) {
      this.itemAttributeList.splice(this.itemAttributeList.indexOf(tag), 1)
    },
    // 请求素材标签信息 - 未调用
    loadTagListData(param) {
      this.$api.tagListDesignElementsInfoApi(param).then((res) => {
        if (res) {
          if (res.length > 0) {
            this.formData.tagList = []
            res.forEach((item) => {
              this.formData.tagList.push(item.value)
            })
          }
        }
      })
    },
    // 重置表单数据
    resetData() {
      this.activeName = '1'
      this.dialogVisible = false
      this.dialogVisible2 = false
      this.disabled = false
      this.categoryOptions = {}
      this.pageHeader = ''
      this.formData = {
        deCode: '',
        deName: '',
        deNameEn: '',
        tagList: [],
        deStatus: 'Y',
        custCode: '',
        deCategoryCode: '',
        deImageCode: '',
        deImageUrl: '',
        deThumbImageCode: '',
        deThumbImageUrl: '',
        deMemo: '',
        createByName: '',
        createDate: '',
        modifyDate: '',
        modifyByName: ''
      }
    },

    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_save_ok') || '保存成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          }
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.text-annotation {
  color: $color-primary;
  font-size: 13px;
}
.avatar-uploader {
  i {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover {
      border-color: #409eff;
    }
  }
}
.icon-right {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.events-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px !important;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
.events-uploader-icon-small {
  font-size: 28px;
  color: #8c939d;
  width: 120px !important;
  height: 80px;
  line-height: 80px !important;
  text-align: center;
}
.events {
  width: 300px !important;
  height: 200px;
  display: block;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
